import { constants } from "../../shared/src/regexes";

export const introducerIdFromQueryString = (raw: string | undefined): string | null =>
    typeof raw === "string" && constants.UUID_REGEX.test(raw)
        ? raw
        : null;
